// 힌트 아이템: 챌린지 1·3·5회째 완료에 각 1개 지급(하루 최대 3개), 하루 지나면 보유분 소멸.
// 지급 한도는 서버(IP 기준)가 최종 결정 → localStorage를 지워도 우회 불가.
// 보유 수/사용은 localStorage(기기별)로 관리. 효과는 연습모드 힌트와 동일(합10 후보 강조).

import { supabase } from './supabase'

const KEY = 'tenblock_hint_items'
const AWARD_AT = [1, 3, 5] // 이 플레이 회차에 지급 시도(서버 허가 시 실제 지급)

type State = { date: string; plays: number; items: number }

function todayStr(): string {
  const d = new Date()
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
}

function load(): State {
  try {
    const raw = localStorage.getItem(KEY)
    if (raw) {
      const s = JSON.parse(raw) as State
      if (s && s.date === todayStr()) return s
    }
  } catch { /* ignore */ }
  return { date: todayStr(), plays: 0, items: 0 } // 새 날 → 초기화(보유 아이템 소멸)
}

function save(s: State) {
  try { localStorage.setItem(KEY, JSON.stringify(s)) } catch { /* ignore */ }
}

/** 챌린지 완료 1회 기록(로컬). 이번이 지급 마일스톤(1·3·5회째)이면 true. */
export function recordPlayLocal(): boolean {
  const s = load()
  s.plays += 1
  save(s)
  return AWARD_AT.includes(s.plays)
}

/** 서버에 IP 일일 한도(3개) 확인 요청 → 허용되면 로컬 보유 +1, granted 반환. */
export async function claimHintFromServer(): Promise<boolean> {
  try {
    const { data, error } = await supabase.rpc('claim_hint_item')
    if (error || !(data as { granted?: boolean } | null)?.granted) return false
    const s = load()
    s.items += 1
    save(s)
    return true
  } catch { return false }
}

/** 현재 보유 힌트 아이템 수(날짜 지나면 0). */
export function getHintItems(): number {
  return load().items
}

/** 힌트 아이템 1개 사용. 성공 시 true. */
export function useHintItem(): boolean {
  const s = load()
  if (s.items <= 0) return false
  s.items -= 1
  save(s)
  return true
}
